import React, { PropsWithChildren } from 'react';

import { isAuthenticated } from '@features/loginSlice';
import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router';

const RequireAuth: React.FC<PropsWithChildren<any>> = ({ children }) => {
  const hasAuth = useSelector(isAuthenticated);
  const location = useLocation();

  if (!hasAuth) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default RequireAuth;
